'use client';

import { useSyncExternalStore } from 'react';
import { getConnectivity, subscribeConnectivity } from './connectivity';

// Reads the shared connectivity store via useSyncExternalStore — the idiomatic
// way to read an external, event-driven value without a setState-in-effect.
//
// The store (see connectivity.ts) picks its signal source per platform: web
// uses `navigator.onLine` + online/offline events (unchanged); native uses the
// @capacitor/network plugin, which — unlike `navigator.onLine` in a WKWebView —
// actually reports airplane mode. The hook's public API is unchanged, so every
// consumer (banner, overlay triggers, MobileNav intercept, AI gating) starts
// working correctly on iOS automatically.

// Server render + first paint assume connectivity (the common case); the store
// reconciles to the real value on hydration.
function getServerSnapshot(): boolean {
  return true;
}

export function useNetworkStatus(): boolean {
  return useSyncExternalStore(subscribeConnectivity, getConnectivity, getServerSnapshot);
}
